import { takeLatest, put } from 'redux-saga/effects';
import { loadAllStatusUpdates, loadStatusUpdates, statusUpdatesLoadingState } from '../actions';
import { appendStatusUpdate, setStatusUpdates, setStatusUpdatesLoading } from '../slice';
function* loadAllStatusUpdatesManager(action) {
    const { payload } = action;
    try {
        yield put(setStatusUpdates(payload));
    } catch (unused) {
    // TODO
    }
}
export const watchLoadAllStatusUpdates = function*() {
    yield takeLatest(loadAllStatusUpdates.type, loadAllStatusUpdatesManager);
};
function* loadStatusUpdatesManager(action) {
    const { payload } = action;
    try {
        yield put(appendStatusUpdate(payload));
    } catch (unused) {
    // TODO
    }
}
export const watchLoadStatusUpdates = function*() {
    yield takeLatest(loadStatusUpdates.type, loadStatusUpdatesManager);
};
function* setStatusUpdatesLoadingStateManager(action) {
    const { payload } = action;
    try {
        yield put(setStatusUpdatesLoading(payload));
    } catch (unused) {
    // TODO
    }
}
export const watchStatusUpdatesLoadingState = function*() {
    yield takeLatest(statusUpdatesLoadingState.type, setStatusUpdatesLoadingStateManager);
};
